module.exports = __webpack_public_path__ + "static/media/mike.aab414f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mike.jpg
// module id = 684
// module chunks = 0